import * as React from 'react';
import { createComponent } from '@lit/react';
import { ButtonWithDifferentDefaultWC } from './button-with-different-default.wc';

export const ButtonWithDifferentDefault = createComponent({
  tagName: ButtonWithDifferentDefaultWC.tagname,
  elementClass: ButtonWithDifferentDefaultWC,
  react: React,
});
